import { createAsyncThunk } from "@reduxjs/toolkit";
import DeliveryNoteApi from "@infrastructure/delivery-note-api";
import { addSuccessNotification } from "../common/notificationSlice";
import { getErrorPayload } from "@application/common/helpers/api-helper";
export const createDeliveryNoteAsync = createAsyncThunk('DeliveryNote/Create', async (debtor, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await DeliveryNoteApi.createDeliveryNote(debtor);
        dispatch(addSuccessNotification('Afleverbon succesvol toegevoegd'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateDeliveryNoteAsync = createAsyncThunk(`DeliveryNote/Update`, async (debtor, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await DeliveryNoteApi.updateDeliveryNote(debtor);
        dispatch(addSuccessNotification('Afleverbon succesvol bijgewerkt'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getDeliverNoteByIdAsync = createAsyncThunk('DeliveryNote/getDeliveryNotebyId', async (debtorId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await DeliveryNoteApi.getDeliveryNotebyId(debtorId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllDeliveryNoteAsync = createAsyncThunk('DeliveryNote/GetAll', async (debtorId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await DeliveryNoteApi.getAllDeliveryNotes(debtorId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
